import i18next from 'i18next';
import { Button } from 'react-bootstrap';
import { FaCheck, FaTimes, FaCog } from 'react-icons/fa';
import { PlatformConfigurableListItem } from 'src/motornet/types';

const BooleanCell = ({ value }: { value: boolean }) => {
	if (value === null || value === undefined) {
		return null;
	}

	return value
		? <FaCheck className="text-success" />
		: <FaTimes className="text-danger" />;
};

export const createColumnsData = (
	onEdit: (item: PlatformConfigurableListItem) => void
) => [
		{
			width: 160,
			accessor: 'vehicleCode',
			id: 'vehicleCode',
			Header: i18next.t('vehicle_code'),
			disableSortBy: true,
			Cell: ({ value }: { value: string | null }) =>
				value ? <span>{value}</span> : null,
		},
		{
			width: 130,
			accessor: 'make',
			id: 'make',
			Header: i18next.t('brand'),
			disableSortBy: true,
		},
		{
			accessor: 'model',
			id: 'model',
			Header: i18next.t('model'),
			width: 120,
			disableSortBy: true,
		},
		{
			width: 210,
			accessor: 'trim',
			id: 'trim',
			Header: i18next.t('car_setup'),
			disableSortBy: true,
		},
		{
			width: 180,
			accessor: 'manufactureCode',
			id: 'manufactureCode',
			Header: i18next.t('builder_code'),
			disableSortBy: true,
			Cell: ({ value }: { value: string | null }) =>
				value ? <span>{value}</span> : null,
		},
		{
			width: 140,
			accessor: 'fuel',
			id: 'fuel',
			Header: i18next.t('fuel_type'),
			disableSortBy: true,
		},
		{
			width: 140,
			accessor: 'bodyType',
			id: 'bodyType',
			Header: i18next.t('vehicle_body'),
			disableSortBy: true,
		},
		{
			width: 110,
			accessor: 'listPrice',
			id: 'listPrice',
			Header: i18next.t('list_price'),
			disableSortBy: true,
			Cell: ({ value }: { value: number | null }) =>
				value != null
					? `€ ${Number(value).toLocaleString('it', {
						minimumFractionDigits: 2,
					})}`
					: null,
		},
		{
			accessor: 'excluded',
			id: 'configurable',
			Header: i18next.t('configurable'),
			disableSortBy: true,
			Cell: ({ row }: any) => (
				<span
					role="button"
					className="d-flex align-items-center gap-2 role-button"
					onClick={(e) => {
						e.stopPropagation();
						onEdit(row.original);
					}}
				>
					<BooleanCell value={!row.original.excluded} />
				</span>
			),
		},
		{
			width: 60,
			id: 'actions',
			Header: '',
			disableSortBy: true,
			headerClassName: 'column-sticky',
			className: 'column-sticky text-end',
			Cell: ({ row }: any) => (
				<Button
					variant="link"
					size="sm"
					className="p-0"
					onClick={(e) => {
						e.stopPropagation();
						onEdit(row.original);
					}}
				>
					<FaCog />
				</Button>
			),
		},
	];
